import isReallyNode from './is-node';

import * as elog from './elog';
import {
  trackEvent as trackMParticleEvent,
  MParticleEventName,
} from './elog/mparticle_tracker';
import { MParticleEvent, MparticleClickedCSPCardEvent } from './elog/mparticle_types';
import { CSPAdditionalTrackingFields, CommonsMParticleListing } from './rql';
import { getCategoryAttributesForMparticle } from './csp_category_helper';

export const CLICK = 'click';
export const VIEW = 'view';
export const SUBMIT = 'submit';
export const INTERACTION = 'interaction';
export const MPARTICLE_EVENT = 'mparticle_event';
export const CTA = 'cta';

export const LISTING_TYPE = 'Listing';
export const CSP_TYPE = 'ComparisonShoppingPage';
export const ARTICLE_TYPE = 'Article';
export const SEARCH_TYPE = 'Search';
export const CATEGORY_TYPE = 'Category';
export const BRAND_TYPE = 'Brand';
export const CURATED_SET_TYPE = 'CuratedSet';
export const MARKDOWN_TYPE = 'Markdown';
export const MARKETING_TYPE = 'Marketing';
export const ALBUM_TYPE = 'Album';

let configuredElog = elog;

export function setElog(elogInstance) {
  configuredElog = elogInstance;
}
export interface TrackingProps {
  tracking?: {
    trackEvent: (data: IEventData) => void;
    getTrackingData: () => any;
  };
}

export type MParticleDataProp = ((data: IEventData) => MParticleEvent) | MParticleEvent;

export interface IEventData {
  componentName?: string;
  bumped?: boolean;
  context?: any;
  eventType?: string;
  entityId?: string | number;
  ids?: string[];
  interactionType?: string;
  position?: number;
  page?: number;
  perPage?: number;
  type?: string;
  url?: string;
  mParticleView?: MParticleDataProp;
  mParticleInteraction?: MParticleDataProp;
  listings?: CommonsMParticleListing.Listings[];
}

export interface IErrorEvent {
  name: string;
  error?: string | Error;
  context?: object;
  ravenOptions?: object;
}

function shouldTrackImpression(data: IEventData): boolean {
  return !!(
    data.type === LISTING_TYPE &&
    data.componentName &&
    (data.ids || data.listings)
  );
}

export function trackView(data: IEventData) {
  configuredElog.view(new configuredElog.events.ComponentsView({
    component_name: data.componentName,
    entity_type: data.type,
    entity_ids: data.ids || [],
    context: JSON.stringify(data.context),
  }));

  const { mParticleView, ...eventData } = data;

  if (mParticleView) {
    const viewData = (typeof (mParticleView) === 'function')
      ? mParticleView(eventData)
      : mParticleView;

    trackMParticleEvent(viewData);
  }

  if (shouldTrackImpression(data)) {
    trackMParticleEvent({
      eventName: MParticleEventName.ListingImpression,
      listingIds: data.ids,
      componentName: data.componentName,
      listings: data.listings,
    });
  }
}

export function trackInteraction(data: IEventData) {
  let fullUrl = data.url;
  if (String(fullUrl)[0] === '/') { fullUrl = window.location.origin + fullUrl; }

  const event = new configuredElog.events.ComponentInteraction({
    component_name: data.componentName,
    interaction_type: data.interactionType || CLICK,
    target_url: fullUrl,
    url: window.location.href,
    referer: document.referrer,
    bumped: data.bumped,
    entity_type: data.type,
    entity_id: String(data.entityId),
    context: JSON.stringify(data.context),
    page: data.page,
    per_page: data.perPage,
    position: data.position,
  });

  configuredElog.interaction(event);

  const { mParticleInteraction, ...eventData } = data;
  if (typeof (mParticleInteraction) === 'function') {
    trackMParticleEvent(mParticleInteraction(eventData));
  } else if (mParticleInteraction) {
    trackMParticleEvent(mParticleInteraction);
  }
}

export function trackCSPClick(
  data: IEventData,
  csp: CSPAdditionalTrackingFields.Fragment,
  mparticleEventData: Partial<MparticleClickedCSPCardEvent>,
): MparticleClickedCSPCardEvent {
  return {
    cspSlug: csp.slug,
    cspId: csp.id,
    componentName: data.componentName,
    eventName: MParticleEventName.ClickedCSPCard,
    position: data.position,
    brand: csp.brand && csp.brand.slug,
    displayStyle: mparticleEventData.displayStyle,
    ...getCategoryAttributesForMparticle(csp),
  };
}

export function trackEvents(data: IEventData) {
  if (isReallyNode) return;

  switch (data.eventType) {
    case VIEW:
      trackView(data);
      break;
    case INTERACTION:
      trackInteraction(data);
      break;
    default:
      trackInteraction(data);
  }
}

export default {
  trackEvents,
};



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/tracker.ts